import { getGlobalAppVar } from '@openclassrooms/utils/global-app';

/**
 * @deprecated
 * ### Description
 * `getCurrentUserFromGlobal` is deprecated because it relies on Twig variables.
 * Please use instead `useCurrentUserContext` from "users" modules of "data-connect-web" package.
 * ### Example
 * ```
 * import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
 * const { isPending, isConnected, userId, currentUser, refetch, clear } = useCurrentUserContext();
 * ```
 */
export function getCurrentUserFromGlobal() {
  const app = getGlobalAppVar();
  return app.user || null;
}

/**
 * @deprecated
 * ### Description
 * `userIsConnected` is deprecated because it relies on Twig variables.
 * Please use instead `useCurrentUserContext` from "users" modules of "data-connect-web" package.
 * ### Example
 * ```
 * import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
 * const { isConnected } = useCurrentUserContext();
 * ```
 */
export function userIsConnected() {
  const user = getCurrentUserFromGlobal();
  return !!(user && user.id);
}

export default {
  getCurrentUserFromGlobal,
  userIsConnected,
};
